var faqAccordion = {
    init: function () {
        var flg = 0;
        var $faqHeading = $('.faqAccordion > dt > button');
        $('.faqAccordion > dd').attr('aria-hidden', true);
        $faqHeading.attr('aria-expanded', false);
        $faqHeading.on('click activate', function () {
            if (flg)
                return false;
            flg = 1;
            var state = $(this).attr('aria-expanded') === 'false' ? true : false;
            $(this).attr('aria-expanded', state);
            $(this).parent().next().slideToggle(function () {
                flg = 0;
            });
            $(this).parent().next().attr('aria-hidden', !state);
            return false;
        });
        $faqHeading.on('keydown', function (event) {
            var keyCode = event.keyCode || e.which;
            if (keyCode === 13) {
                $(this).trigger('activate');
            }
        });
    },
    unload: function ($target) {
        $('.faqAccordion > dt > button').off('click activate');
        $('.faqAccordion > dt > button').off('keydown');
    }
}
function product_hide(id) {
    // $("#shopify-section-16051144681ebccd8e").css("display", "none");
    // $("#shopify-section-1605367870c6370196").css("display", "none");
    // $("#shopify-section-1605310110c71a5b47").css("display", "none");
    // $("#shopify-section-1605326219f0a06292").css("display", "none");
    // $("#" + id).show();
  	this_fproduct=id;
    if($("#"+ id + " input[type='radio']").length > 0){
      $("#"+ id + " input[type='radio']").eq(0).click();
    }
}
var this_fproduct = "shopify-section-1605367870c6370196";
$(document).ready(function ($) {
    console.log("ready!");
    $(".c_openwoordintr").click(function () {
        //$("#shopify-section-160644613865ccbcce").show();
    });
    $("#shopify-section-160644613865ccbcce #wood-close").click(function () {
        $("#shopify-section-160644613865ccbcce").hide(300);
    });
    //faqAccordion.init();
    $('#example1').sliderPro({
        width: 1180,
        height: 664,
        arrows: true,
      	fade:true,
        buttons: false,
        waitForLayers: true,
        thumbnailWidth: 300,
        thumbnailHeight: 199,
        thumbnailPointer: true,
      	thumbnailArrows: true,
        autoplay: false,
        autoScaleLayers: false,
        breakpoints: {
            500: {
                thumbnailWidth: 120,
                thumbnailHeight: 86
            }
        }
    });
    product_hide("shopify-section-1605367870c6370196");
    $("#shopify-section-16053100277a390227 img").each(function (index) {
        $(this).click(function () {
          var cId="";
            if (index == 0) {
                cId="shopify-section-16051144681ebccd8e";
            }
            if (index == 1) {
                cId="shopify-section-1605310110c71a5b47";
            }
            if (index == 2) {
                cId="shopify-section-1605367870c6370196";
            }
            if (index == 3) {
                cId="shopify-section-1605326219f0a06292";
            }
          	product_hide(cId);
            document.documentElement.scrollTop=$("#" + cId).offset().top;
        })
    });
  
  $("#shopify-section-16053100277a390227 button").each(function (index) {
        $(this).click(function () {
          var cId="";
            if (index == 0) {
                cId="shopify-section-16051144681ebccd8e";
            }
            if (index == 1) {
                cId="shopify-section-1605310110c71a5b47";
            }
            if (index == 2) {
                cId="shopify-section-1605367870c6370196";
            }
            if (index == 3) {
                cId="shopify-section-1605326219f0a06292";
            }
          	product_hide(cId);
            document.documentElement.scrollTop=$("#" + cId).offset().top;
        })
    });
  
  $("#shopify-section-16080826372c931f63 a").each(function(index){
  $(this).click(function () {
    		var cId="";
            if (index == 1) {
                cId="shopify-section-16051144681ebccd8e";
            }
            if (index == 2) {
                cId="shopify-section-1605310110c71a5b47";
            }
            if (index == 0) {
                cId="shopify-section-1605367870c6370196";
            }
            if (index == 3) {
                cId="shopify-section-1605326219f0a06292";
            }
    
            product_hide(cId);
    
    		document.documentElement.scrollTop=$("#" + cId).offset().top;

            return false;

        })
  });
  // $(".btnGoBuyNow").click(function(){
  //   //console.log("do by now");
  //   document.documentElement.scrollTop=$("#" + this_fproduct).offset().top;
  //           return false;

  // });
  
})

var tag = document.createElement('script');
  tag.id = 'iframe-demo';
  tag.src = 'https://www.youtube.com/iframe_api';
  var firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

  var player;
  function onYouTubeIframeAPIReady() {
    player1 = new YT.Player('yPlayer1', {
      height: '100%',
          width: '100%',
          videoId: 'BY-dzLphJME',
        events: {
          'onReady': onPlayerReady,
          'onStateChange': onPlayerStateChange
        }
    });
        player2 = new YT.Player('yPlayer2', {
      height: '100%',
          width: '100%',
          videoId: 'suwlaz3dxwQ',
        events: {
          'onReady': onPlayerReady,
          'onStateChange': onPlayerStateChange
        }
    });
        player3 = new YT.Player('yPlayer3', {
      height: '100%',
          width: '100%',
          videoId: 'NuWmYsozFXU',
        events: {
          'onReady': onPlayerReady,
          'onStateChange': onPlayerStateChange
        }
    });
        player4 = new YT.Player('yPlayer4', {
      height: '100%',
          width: '100%',
          videoId: 'qcE4qyTWAQE',
        events: {
          'onReady': onPlayerReady,
          'onStateChange': onPlayerStateChange
        }
    });
  }
  
  function onPlayerReady(event) {
    //document.getElementById('yPlayer1').style.borderColor = '#FF6D00';
  }

  function onPlayerStateChange(event) {
    var playerId=jQuery(event.target.getIframe()).attr('id');
    if(event.data==1){
      if(playerId=="yPlayer1"){
      player2.pauseVideo();
        player3.pauseVideo();
        player4.pauseVideo();
      }
      if(playerId=="yPlayer2"){
      player1.pauseVideo();
        player3.pauseVideo();
        player4.pauseVideo();
      }
      if(playerId=="yPlayer3"){
      player1.pauseVideo();
        player2.pauseVideo();
        player4.pauseVideo();
      }
      if(playerId=="yPlayer4"){
      player1.pauseVideo();
        player3.pauseVideo();
        player2.pauseVideo();
      }
    }
  }